const WORKFLOW_STATES = "workflowStates";
const CANCEL_STATES = "cancellation_states";
const WORKFLOW_CANCEL_STATES = "workflow_cancellation_states";
const OTHER_STATES = "other_states";

export default class SharedStatusService {
  constructor() {
    this.statuses = [
      {
        key: "IMPORTED",
        label: "geïmporteerd",
        type: WORKFLOW_STATES
      },
      {
        key: "TO_BE_PLANNED",
        label: "te plannen",
        type: WORKFLOW_STATES
      },
      {
        key: "PLANNED",
        label: "gepland",
        type: WORKFLOW_STATES
      },
      {
        key: "IN_PROGRESS",
        label: "onderhanden monteurs",
        type: WORKFLOW_STATES
      },
      {
        key: "TO_BE_VERIFIED",
        label: "te verwerken",
        type: WORKFLOW_STATES
      },
      {
        key: "DONE",
        label: "gereed",
        type: WORKFLOW_STATES
      },
      {
        key: "CANCELLED_NOT_PRESENT_ON_SCHEDULE_APPOINTMENT",
        label: "niet aanwezig op moment van plannen",
        type: CANCEL_STATES
      },
      {
        key: "CANCELLED_NOT_PRESENT_AT_APPOINTMENT",
        label: "niet aanwezig op afspraak",
        type: CANCEL_STATES
      },
      {
        key: "CANCELLED_BY_PHONE",
        label: "afgebeld",
        type: CANCEL_STATES
      },
      {
        key: "CANCELLED",
        label: "geannuleerd - overig",
        type: CANCEL_STATES
      },
      {
        key: "TO_BE_INSPECTED",
        label: "nog te schouwen",
        type: OTHER_STATES
      },
      {
        key: "PARTIALLY_DONE",
        label: "gedeeltelijk gereeed",
        type: OTHER_STATES
      },
      {
        key: "NO_REACTION_ON_NOT_AT_HOME",
        label: "geen reactie op niet thuis brief",
        type: OTHER_STATES
      },
      {
        key: "NOT_DO_ABLE",
        label: "niet uitvoerbaar",
        type: WORKFLOW_CANCEL_STATES
      }
    ];
  }

  isWorkflowState(type) {
    return type === WORKFLOW_STATES || type === WORKFLOW_CANCEL_STATES;
  }

  isCancelState(type) {
    return type === CANCEL_STATES || type === WORKFLOW_CANCEL_STATES;
  }

  resolveWorkFlowStatuses() {
    return this.statuses.filter(e => this.isWorkflowState(e.type));
  }

  resolveCancelStatuses() {
    return this.statuses.filter(
      e => this.isCancelState(e.type) || e.type === OTHER_STATES
    );
  }

  resolveOtherStatuses() {
    return this.statuses.filter(e => e.type === OTHER_STATES);
  }

  resolveAllStatuses() {
    return this.statuses;
  }

  resolveItem(key) {
    return this.statuses.find(e => e.key === key)
  }

  resolveLabel(key) {
    let matchedStatus = this.statuses.find(e => e.key === key);
    return matchedStatus.label;
  }
}
